import { IdCardSection } from "../IdCardSection";
import { SectionHeader } from "../SectionHeader";

interface IdCardsSectionProps {
  contactId: string;
  isVisible: boolean;
  onToggle: (sectionName: string) => void;
}

export const IdCardsSection = ({ 
  contactId, 
  isVisible, 
  onToggle 
}: IdCardsSectionProps) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6">
        <SectionHeader 
          title="ID Cards" 
          sectionName="id_cards"
          isVisible={isVisible}
          onToggle={onToggle}
        />
        {isVisible && <IdCardSection contactId={contactId} />}
      </div>
    </div>
  );
};